import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Alert from '../common/Alert';
import FormInput from '../common/FormInput';
import Button from '../common/Button';
import useApi from '../../hooks/useApi';

/**
 * Change Password component
 */
function ChangePassword() {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const { post } = useApi();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Basic validation
    if (formData.newPassword !== formData.confirmNewPassword) {
      setError('New password and confirmation do not match.');
      return;
    }

    try {
      const response = await post('/api/users/change-password', {
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword,
      });
      setSuccess(response.message || 'Password changed successfully!');
      toast.success('Password changed successfully!');
      setTimeout(() => navigate('/profile'), 2000);
    } catch (err) {
      console.error('Change Password error:', err.response?.data || err);
      const errorMessage = err.response?.data?.error || 'Failed to change password.';
      setError(errorMessage);
      toast.error('Failed to change password.');
    }
  };

  return (
    <div className="container mt-5 animate__animated animate__fadeIn">
      <h2 className="text-center mb-4">Change Password</h2>
      <div className="card shadow">
        <div className="card-body">
          <h5 className="card-title">Update Your Password</h5>
          {error && <Alert type="danger" message={error} />}
          {success && <Alert type="success" message={success} />}
          <form onSubmit={handleSubmit}>
            <FormInput
              label="Current Password"
              name="currentPassword"
              type="password"
              value={formData.currentPassword}
              onChange={handleChange}
              required
            />
            <FormInput
              label="New Password"
              name="newPassword"
              type="password"
              value={formData.newPassword}
              onChange={handleChange}
              required
              minLength={6}
              title="Password must be at least 6 characters long"
            />
            <FormInput
              label="Confirm New Password"
              name="confirmNewPassword"
              type="password"
              value={formData.confirmNewPassword}
              onChange={handleChange}
              required
            />
            <div className="d-flex gap-2">
              <Button type="submit" variant="primary" className="w-50">
                Change Password
              </Button>
              <Button
                type="button"
                variant="secondary"
                className="w-50"
                onClick={() => navigate('/profile')}
              >
                Cancel
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;